$ = require 'jquery'
BoardDisplayHelpers = require 'app/scripts/views/internal/board-display-helpers'
BoardSelectOrganizationForPermChangeView = require 'app/scripts/views/board-menu/board-select-organization-for-perm-change-view'
ConfirmationPublicBoardsView = require 'app/scripts/views/board/confirmation-public-boards-view'
Confirm = require 'app/scripts/views/lib/confirm'
{ featureFlagClient } = require '@trello/feature-flag-client'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
{ track, trackUe } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'
boardMenuVisTemplate = require 'app/scripts/views/templates/board_menu_vis'

module.exports = class ChangeBoardVisibilityView extends View
  viewTitleKey: ->
    if @model.owned()
      'change visibility'
    else
      'visibility'

  tagName: 'ul'

  initialize: ->
    @isTemplate = @options.templateFlagEnabled && @model.isTemplate()
    featureFlagClient.on 'publicproduct.templates_v1', (newVal) =>
      @isTemplate = newVal && @model.isTemplate()

    @listenTo(@model, 'change', @render)
    return

  className: 'pop-over-list'

  maxWidth: 370

  events:
    'click .js-select': 'selectVis'

  render: ->
    org = @model.getOrganization()
    enterprise = org?.getEnterprise()

    @$el.html boardMenuVisTemplate
      canChange: @model.owned()
      current: @model.getPref('permissionLevel')
      hasSuperAdmins: org?.isFeatureEnabled('superAdmins')
      hasOrg: org?
      orgName: org?.get('displayName')
      privateRestricted: org? && !org?.canSetVisibility('private')
      orgRestricted: org? && !org?.canSetVisibility('org')
      enterpriseRestricted: org? && !org?.canSetVisibility('enterprise')
      publicRestricted: org? && !org?.canSetVisibility('public')
      hasEnterprise: enterprise?
      enterpriseName: enterprise?.get('displayName')
      isTemplate: @isTemplate

    @

  selectVis: (e) ->
    Util.stop(e)

    $target = $(e.target).closest('.js-select')

    if $target.hasClass('disabled') || $target.closest('.js-disabled').length
      return

    setting = $target.attr('name')
    change = if @model.getPref('permissionLevel') != setting then 1 else 0

    if setting == 'public'
      PopOver.pushView
        elem: e.target
        view: new ConfirmationPublicBoardsView({
          @model,
          @modelCache,
        })
        maxWidth: 370

      return

    if setting == 'org' && !@model.getOrganization()
      # show org picker
      PopOver.pushView
        view: BoardSelectOrganizationForPermChangeView
        options:
          model: @model
          modelCache: @modelCache
          disableNone: true
      return

    @model.setPref('permissionLevel', setting)
    @model.save()

    if setting == 'org'
      trackUe('board', 'sets', 'board visibility', '', 'to team', '', { boardid: @model.id, change: change })
    else if setting == 'private'
      trackUe('board', 'sets', 'board visibility', '', 'to private', '', { boardid: @model.id, change: change })
    else if setting == 'enterprise'
      trackUe('board', 'sets', 'board visibility', '', 'to enterprise', '', { boardid: @model.id, change: change })

    PopOver.popView()

    return
